module.exports = __webpack_public_path__ + "static/media/facebook.a6a8410b.svg";